import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { base_url } from "../utils/baseUrl";


const DataTable = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${base_url}uffta/getAllUFFTA`); // Replace '/api/data' with your backend API endpoint
      setData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleApprove = async (id) => {
    try {
      await axios.put(`${base_url}uffta/updateUFFTAById/${id}`, { isVerified: true }); // Replace '/api/data' with your backend API endpoint
      fetchData();
    } catch (error) {
      console.error('Error approving data:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${base_url}uffta/deleteUFFTAById/${id}`); // Replace '/api/data' with your backend API endpoint
      fetchData();
    } catch (error) {
      console.error('Error deleting data:', error);
    }
  };

  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Address</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((entry) => (
            <tr key={entry._id}>
              <td>{entry.name}</td>
              <td>{entry.email}</td>
              <td>{entry.phone}</td>
              <td>{entry.address}</td>
              <td>
                <div className="d-flex flex-column flex-md-row align-items-md-center">
                  <button
                    className="btn btn-success mb-2 mb-md-0 me-md-2"
                    onClick={() => handleApprove(entry._id)}
                    disabled={entry.isVerified}
                  >
                    Approve
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => handleDelete(entry._id)}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
